import { Auth } from 'aws-amplify'
import React, { useEffect } from 'react'
import { useState } from 'react'
import getTFIDBPageJSONQuerieV2 from '../../Services/Queries/getTFIDBPageJSONQuerieV2'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ToastStyle } from '../Data/MovieStaticData'
// import JSONInput from 'react-json-editor-ajrm'
// import locale from 'react-json-editor-ajrm/locale/en'

import updateTFIDBPageJSONMutation from '../../Services/Mutations/updateTFIDBPageJSONMutation'
export default function DynamicListPageJson() {
  // const [pageJson] = useState('')
  const [parseError, setParseError] = useState(false)
  // const [JsonDataValue11, setJsonDataValue11] = useState()

  const [JsonDataValue, setJsonDataValue] = useState('')

  const handlePageJson = e => {
    e.preventDefault()
    // const obj = JSON.parse(e.target.value)

    setJsonDataValue(e.target.value)
    // setPageJson(JSON.parse(e.target.value))
  }

  const handleUpdateJson = async () => {
    try {
      const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
      const jsonObject = JSON.parse(JsonDataValue)

      jsonObject.JSON.map(item => {
        delete item.__typename
        return item
      })
      delete jsonObject.__typename

      const removeTypename = obj => {
        for (const key in obj) {
          if (key === '__typename') {
            delete obj[key]
          } else if (typeof obj[key] === 'object') {
            removeTypename(obj[key])
          }
        }
      }

      // Clone the array to avoid modifying the state directly
      const newArray = jsonObject.JSON.map(obj => {
        const clonedObj = { ...obj }
        removeTypename(clonedObj)
        return clonedObj
      })

      const input = {
        PK: jsonObject.PK,
        SK: jsonObject.SK,
        moderatorID: Auth.user.username,
        moderatorHandle: '@' + loggedInUserEmail.split('@')[0],
        JSON: newArray,
      }

      const UpdatedJson = await updateTFIDBPageJSONMutation(input)

      if (UpdatedJson.data.updateTFIDBPageJSON.statusCode === 'A046') {
        toast.success('JSON Updated Successfully', ToastStyle)
      }
    } catch (e) {
      setParseError(true)

      return e
    }
  }

  useEffect(() => {
    const data = async () => {
      const jsonData = await getTFIDBPageJSONQuerieV2()

      setJsonDataValue(JSON.stringify(jsonData.getTFIDBPageJSONV2, null, 2))
      // setJsonDataValue11(jsonData.getTFIDBPageJSONV2)
    }

    data()
  }, [])

  return (
    <div>
      <h3>TFIDB Page Json</h3>

      <textarea
        rows='40'
        cols='100'
        onChange={e => handlePageJson(e)}
        value={JsonDataValue}
      ></textarea>

      {parseError && (
        <div className='alert alert-danger'>
          Error parsing json . Please check the json and try again
        </div>
      )}
      <button className='btn btn-primary mt-2' onClick={() => handleUpdateJson()}>
        Update Json
      </button>
    </div>
  )
}
